module.exports = __webpack_public_path__ + "static/media/prod13-bg.7b72f81e.png";